import ZaiaSplash from './ZaiaSplash';

export default ZaiaSplash;